import ChatBot from "../models/ChatBotModel";
import Keyword from "../models/KeywordModel";
import request from "../shared/http";
import appConfig from "../shared/js/app-config";

const serviceId = appConfig.getServiceId();
class AutomationService {
    parse(item) {
        return {
            id: item.id,
            serviceId: item.service_id,
            templateName: item.chatbot_name,
            template: item.template_json,
            status: item.status,
            trigger: item.trigger ?? 'Event',
            description: item.description ?? 'Remind customers about abandoned cart',
            action: item.action ?? 'Send Message',
            contacts: item.contacts ?? '12',
            lastRun: item.last_run ?? '1hr ago',
            nextRun: item.next_run ?? 'Tomorrow',
            sourceDefaultChatbotId: item.source_default_chatbot_id ?? null,
        }
    }

    keywordParse(item) {
        return {
            id: item.id,
            serviceId: item.service_id,
            keyword: item.keyword,
            triggerNo: item.trigger_no,
            replyMaterial: item.reply_material,
            chatbotName: item.chatbot_name,
            chatbotId: item.chatbot_id,
            matchMethod: item.match_method,
            templateId: item.template_id,
        }
    }

    serialize(model) {
        return {
            id: model.getId(),
            service_id: model.getServiceId(),
            temlate_name: model.getTemplateName(),
            template_json: model.getTemplate(),
            status: model.getStatus(),
        }
    }
    
    async getChatBot() {
        const url = `/chatbot/${appConfig.getServiceId()}`
        const { data } = await request.get(url);
        const response =  data?.map((model) => new ChatBot(this.parse(model)))
        return response;
    }

    async saveKeyWordAction(action) {
        console.log('action', action);
        
        const url = `/keyword/action/${appConfig.getServiceId()}`;
        const { data } = await request.put(url, action);
        return data;
    }

    async getKeyWords() {
        const url = `/keywords/${appConfig.getServiceId()}`;
        const { data } = await request.get(url);
        const response = data.map((model) => new Keyword(this.keywordParse(model)));
        console.log('res', response);
        
        return response;
    }

    async getNoKeywordFallbackConfig() {
        const url = `/no_keyword_fallback/${appConfig.getServiceId()}`;
        const { data } = await request.get(url);
        return data;
    }

    async saveNoKeywordFallbackConfig(config) {
        const url = `/no_keyword_fallback/${appConfig.getServiceId()}`;
        const { data } = await request.put(url, config);
        return data;
    }

    async createChatBot(chatbot) {
        const url = `/chatbot/${appConfig.getServiceId()}`;
        const { data } = await request.put(url, chatbot);
        return data;

    }

    async deleteKeyWord(id) {
        const url = `/keyword/delete/${id}`;
        return request.delete(url);
    }

    async deleteChatbot(id) {
        const url = `/chatbot/delete/${id}`;
        return request.delete(url);
    }

    async getDefaultChatbots() {
        const url = `/chatbot/defaults/list`;
        const { data } = await request.get(url);
        return (data || []).map((model) => this.parse(model));
    }

    async getDefaultChatbotById(defaultId) {
        const url = `/chatbot/defaults/${defaultId}`;
        const { data } = await request.get(url);
        return this.parse(data);
    }

    async cloneDefaultChatbot(defaultId, serviceId = appConfig.getServiceId()) {
        const url = `/chatbot/defaults/${defaultId}/clone/${serviceId}`;
        const { data } = await request.post(url);
        return data;
    }

    async duplicateChatbot(chatbotId, { name } = {}) {
        const url = `/chatbot/${appConfig.getServiceId()}/${chatbotId}/duplicate`;
        const payload = {};
        if (name != null && String(name).trim()) {
            payload.name = String(name).trim();
        }
        const { data } = await request.post(url, payload);
        return data;
    }

    async getForms(serviceId = appConfig.getServiceId()) {
        const url = `/forms/${serviceId}`;
        const { data } = await request.get(url);
        return Array.isArray(data) ? data : [];
    }

    async createForm(serviceId, body) {
        const url = `/forms/${serviceId}`;
        const { data } = await request.post(url, body);
        return data;
    }

    async updateForm(serviceId, id, body) {
        const url = `/forms/${serviceId}/${id}`;
        const { data } = await request.put(url, body);
        return data;
    }

    async deleteForm(id) {
        const url = `/forms/${id}`;
        return request.delete(url);
    }

    async getAutomationRules() {
        const url = `/automation/rules/${appConfig.getServiceId()}`;
        const { data } = await request.get(url);
        return Array.isArray(data) ? data : [];
    }

    async createAutomationRule(payload) {
        const url = `/automation/rules/${appConfig.getServiceId()}`;
        const { data } = await request.post(url, payload);
        return data;
    }

    async updateAutomationRule(id, payload) {
        const url = `/automation/rules/${appConfig.getServiceId()}/${id}`;
        const { data } = await request.put(url, payload);
        return data;
    }

    async deleteAutomationRule(id) {
        const url = `/automation/rules/${appConfig.getServiceId()}/${id}`;
        return request.delete(url);
    }

    async getAutomationRuleLogs(limit = 100) {
        const url = `/automation/rules/${appConfig.getServiceId()}/logs?limit=${limit}`;
        const { data } = await request.get(url);
        return Array.isArray(data) ? data : [];
    }
}
export default new AutomationService();